import React, { useState } from "react";
import { IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MdClose } from "@react-icons/all-files/md/MdClose";
import { Note, SheetContainer } from "../../../styles/common";
import { DrawerBody, Header } from "./infoBottomSheet.styles";

interface InfoBottomSheetProps {
  mainMessage: string;
  title: string;
  detailMessage: string;
}
function InfoBottomSheet({
  mainMessage,
  title,
  detailMessage,
}: InfoBottomSheetProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <Note severity="info">
        <Typography component={"span"}>{mainMessage}</Typography>
        <Typography
          fontWeight={600}
          color="primary"
          component={"span"}
          sx={{ textDecoration: "underline", cursor: "pointer" }}
          onClick={() => setOpen((prev) => !prev)}
        >
          {t("learn_more", {
            defaultValue: "Learn more.",
          })}
        </Typography>
      </Note>
      <SheetContainer
        open={open}
        anchor="bottom"
        onClose={() => setOpen(false)}
      >
        <Header>
          <Typography variant="h6">{title}</Typography>
          <IconButton onClick={() => setOpen((prev) => !prev)}>
            <MdClose />
          </IconButton>
        </Header>
        <DrawerBody>
          <Typography>{detailMessage}</Typography>
        </DrawerBody>
      </SheetContainer>
    </>
  );
}

export default InfoBottomSheet;
